import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ForgotPassword from "../components/ForgotPassword";

export default withRouter(connect()(ForgotPassword));
